import { useState, useEffect, useContext } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../views/firebase/firebase';
import { AuthUserContext } from '../views/session';

const TIER_LEVELS = { free: 0, supporter: 1, creator: 2, lifetime: 3 };

const DEFAULT_SUBSCRIPTION = {
  tier: 'free',
  status: 'active',
  stripeCustomerId: null,
  stripeSubscriptionId: null,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: false,
};

const useSubscription = () => {
  const { authUser } = useContext(AuthUserContext);
  const [subscription, setSubscription] = useState(DEFAULT_SUBSCRIPTION);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authUser?.uid) {
      setSubscription(DEFAULT_SUBSCRIPTION);
      setLoading(false);
      return;
    }

    const subRef = ref(db, `users/${authUser.uid}/subscription`);
    const unsubscribe = onValue(subRef, (snapshot) => {
      const data = snapshot.val();
      setSubscription(data ? { ...DEFAULT_SUBSCRIPTION, ...data } : DEFAULT_SUBSCRIPTION);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [authUser?.uid]);

  const can = (requiredTier) => {
    const userLevel = TIER_LEVELS[subscription.tier] ?? 0;
    const requiredLevel = TIER_LEVELS[requiredTier] ?? 0;
    // also check that subscription is not canceled/past_due (unless lifetime)
    const isActive = subscription.tier === 'lifetime' || subscription.status === 'active' || subscription.status === 'trialing';
    return isActive && userLevel >= requiredLevel;
  };

  return {
    ...subscription,
    loading,
    can,
  };
};

export default useSubscription;
